import React from 'react';

// DEF-EXPQ-11 fix: old copy "showing first 100" implied truncation but no
// truncation occurs — all results (up to 150 fetched) are shown via pagination.
interface TooManyResultsBannerProps {
  /**
   * S-DM-006: the resolved match count — `totalCount` when the response carried
   * one, otherwise the `nodes.length` fallback. Omitted => generic copy.
   */
  total?: number;
  /** True when `total` exceeds the rows rendered on this page. */
  isPartialPage?: boolean;
}

export default function TooManyResultsBanner({
  total,
  isPartialPage = false,
}: TooManyResultsBannerProps = {}): React.ReactElement {
  const text =
    typeof total === 'number' && isPartialPage
      ? `${total} matches — more than fit on one page. Use filters to narrow your search.`
      : `${typeof total === 'number' ? total : 100}+ results — use filters to narrow your search.`;

  return (
    <div className="too-many-results-banner" data-testid="too-many-results-banner">
      {text}
    </div>
  );
}
